import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

import { AulaEditorWrapper } from './AulaEditor.styles';

const withCustomStyles = (AulaEditor) => {
  const AulaEditorWithCustomStyles = forwardRef((props: any, ref) => {
    const { isSubmitting } = props;

    return (
      <AulaEditorWrapper readOnly={isSubmitting}>
        <AulaEditor ref={ref} {...props} />
      </AulaEditorWrapper>
    );
  });

  AulaEditorWithCustomStyles.displayName = 'AulaEditorWithCustomStyles';

  AulaEditorWithCustomStyles.propTypes = {
    isSubmitting: PropTypes.bool,
  };

  return AulaEditorWithCustomStyles;
};

export default withCustomStyles;
